import { useCallback } from 'react';

import { TranslatableText, useBoolean } from '@dreryk/react-common';

import { PatientMedicalInformationFaultModal } from './PatientMedicalInformationFaultModal';

type PatientMedicalInformationFaultModalRenderProps = Readonly<{ description: TranslatableText }>;

type UsePatientMedicalInformationFaultModalReturnFn = Readonly<{
   renderPatientMedicalInformationFaultModal: (
      renderProps: PatientMedicalInformationFaultModalRenderProps
   ) => JSX.Element | null;
   openPatientMedicalInformationFaultModal: VoidFunction;
}>;

export const usePatientMedicalInformationFaultModal = (): UsePatientMedicalInformationFaultModalReturnFn => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return {
      openPatientMedicalInformationFaultModal: openModal,
      renderPatientMedicalInformationFaultModal: useCallback(
         ({ description }) => {
            if (modalOpened) {
               return <PatientMedicalInformationFaultModal description={description} onClose={closeModal} />;
            }

            return null;
         },
         [closeModal, modalOpened]
      ),
   };
};
